export const partnerSharesInitValue = {
  data: {
    totalShares: 0,
    shares: [],
    sharesTitles: [],
    societyShareTitleDocument: null,
    societySharesTitleDocumentWithCoOwners: null,
    societyId: '',
    societyShareTitleTextPadding: undefined,
    page: 1,
    rowsPerPage: 10,
    hasSharesTitlesEnabled: false,
    isSocietyShareTitleLandscape: false,
    isAdmin: false,
    isCoOwner: false,
    showEncumbranceColumn: false,
    showSharesTitleColumn: false,
    isReadOnly: false,
    isLoadingShares: false,
    isLoading: false,
  },
  actions: {
    handleChangePage: () => {},
    handleChangeRowsPerPage: () => {},
    handleClickShare: () => {},
  },
};
